interface BrandLogoProps {
  tone?: "light" | "dark";
  /** "lg" é usado no rodapé; "md" no cabeçalho e no menu mobile. */
  size?: "md" | "lg";
}

/**
 * Logo textual da Auréa.
 *
 * Aplicação tipográfica elegante, sem símbolo complexo: o nome em destaque e o
 * complemento "Calçados & Acessórios" logo abaixo.
 */
export default function BrandLogo({ tone = "dark", size = "md" }: BrandLogoProps) {
  const light = tone === "light";

  const nameClass =
    size === "lg"
      ? "font-heading text-3xl font-semibold tracking-[0.28em] uppercase"
      : "font-heading text-[22px] font-semibold tracking-[0.24em] uppercase md:text-[26px]";

  const subClass =
    size === "lg"
      ? "mt-1 text-[11px] uppercase tracking-[0.26em]"
      : "mt-0.5 text-[8px] uppercase tracking-[0.24em] md:text-[9px]";

  return (
    <span className="flex flex-col leading-none">
      <span className={`${nameClass} ${light ? "text-background-50" : "text-foreground-900"}`}>
        Auréa
      </span>
      <span
        className={`${subClass} ${
          light ? "text-background-100/90" : "text-foreground-600"
        }`}
      >
        Calçados &amp; Acessórios
      </span>
    </span>
  );
}